import {
  ValidationProvider,
  ValidationObserver,
} from "@/globalComponents/validation";

export default {
  ValidationProvider,
  ValidationObserver,
};
